import { useSetAtom } from 'jotai';
import { useMemo } from 'react';

import type { ComputerUseReadiness } from '@/tauri/rpa';

import { ensurePermissionsAtom, showComputerUseRefusalAtom } from '../atoms';
import type { PermissionMode } from '../types';

export interface DesktopPermissionGateApi {
  /**
   * Preflight the permissions a `mode` needs. Resolves `true` when already
   * granted; otherwise opens the gate modal/overlay and resolves `false` so the
   * caller can abort. Backed by jotai — works anywhere under the app's store,
   * no provider required.
   */
  ensurePermissions: (mode: PermissionMode) => Promise<boolean>;
  /** No-op when this build cannot run computer use */
  showComputerUseRefusal: (readiness: ComputerUseReadiness) => void;
}

export function useDesktopPermissionGate(): DesktopPermissionGateApi {
  const ensurePermissions = useSetAtom(ensurePermissionsAtom);
  const showComputerUseRefusal = useSetAtom(showComputerUseRefusalAtom);
  return useMemo(
    () => ({ ensurePermissions, showComputerUseRefusal }),
    [ensurePermissions, showComputerUseRefusal]
  );
}
